// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"499":"05a62a5f","502":"e9e5cf55","654":"ee203963","666":"c63f8707","695":"0cd35f90"}[chunkId] + ".chunk.js";
};